<template>
  <div class="position-relative">
    <ParentDefaultCard></ParentDefaultCard>
    <ParentDefaultCard></ParentDefaultCard>
    <ParentDefaultCard></ParentDefaultCard>
    <ParentDefaultCard></ParentDefaultCard>
    <ParentDefaultCard></ParentDefaultCard>

    <EmptyContent
      display_img="EmptyTeacher.png"
      display_text="No parent have been linked up to your school list yet."
      button_type="emit"
      :show_button="false"
      button_text="Add Parent"
      button_function="toggleTeacher"
      :show_empty="show_empty"
      @toggleTeacher="$emit('toggleTeacher')"
    ></EmptyContent>
  </div>
</template>

<script>
import EmptyContent from "@/components/globalComps/EmptyContent";
import ParentDefaultCard from "@/components/schoolComps/dashboard/parent/ParentDefaultCard";

export default {
  name: "ParentDefaultInfo",

  props: {
    show_empty: Boolean
  },

  components: {
    EmptyContent,
    ParentDefaultCard
  }
};
</script>

<style lang="scss">
</style>
